<template>
  <div class="home">
    <app-header style="margin-bottom:3%;"></app-header>
    <app-rtap-header style="margin-bottom:2%;"></app-rtap-header>
    <app-our-clients></app-our-clients>
    <app-footer></app-footer>
  </div>
</template>

<script>
// @ is an alias to /src
import Header from "@/components/general/Header.vue";
import RTapHeader from "@/components/general/RTapHeader.vue";
import OurClients from "@/components/rtap/OurClients.vue";
import Footer from "@/components/general/Footer.vue";

export default {
name: "home",
components: {
  'app-header': Header,
  'app-rtap-header': RTapHeader,
  'app-our-clients': OurClients,
  'app-footer' : Footer,
  }
}   

</script>
